<div class="dialog" (click)="handleCloseClick()">

    <!-- laoding -->
    <div *ngIf="!imageLoaded" class="dialog__loading flex flex-column p-8">
        <app-spinner size="huge">
        </app-spinner>
    </div>

    <!-- image -->
    <img class="dialog__image" [src]="config.src" [title]="config.title || ''" [alt]="config.alt || ''" (load)="handleImageLoaded()">
    
    <button
        class="dialog__close"
        app-pin-button
        buttonType="dark"
        size="large"
        icon="times"
        aria-label="Close"
        matTooltip="Close"
        matTooltipPosition="left">
    </button>

</div>